import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  ViewContainerRef,
  input,
  model,
  viewChild,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ITimeBlockComponentItem } from '../../../../features/calendar/components/time-block/types/time-block-component-item-types';
import { TimePickerComponent } from '@progress/kendo-angular-dateinputs';
import { SubSink } from 'subsink';
import { AbsencePopupComponent } from '../../../../features/calendar/dialogs/time-entry-dialog/absence-type-dialog/absence-popup/absence-popup.component';
import { faCircleInfo } from '@fortawesome/pro-light-svg-icons';
import { TimeOfDayValues } from '../../../data-types/dropdown-option';
import { IntervalTypes } from '../../../../features/calendar/calendar-types';
import { FixInterval } from '../../../../features/calendar/components/time-block/types/time-block-types';
import { timeDialogFormControls } from './date-and-time-input-dialog.constants';

@Component({
  selector: 'app-date-and-time-input-dialog',
  templateUrl: './date-and-time-input-dialog.component.html',
  styleUrls: ['./date-and-time-input-dialog.component.scss'],
  standalone: false,
})
export class DateAndTimeInputDialogComponent implements OnInit, AfterViewInit, OnDestroy {
  readonly timeFrom = viewChild<TimePickerComponent>(timeDialogFormControls.TimeFrom);
  readonly timeTo = viewChild<TimePickerComponent>(timeDialogFormControls.TimeTo);
  readonly form = input.required<FormGroup>();
  readonly timeBlock = input.required<ITimeBlockComponentItem>();
  readonly workTimeStart = input.required<Date>();
  readonly workTimeEnd = input.required<Date>();
  readonly fixIntervalDropdownVisible = model<boolean>(false); // Either the dropdown or start / end datetime picker are visible.
  readonly intervalSelectable = model(false); // Show / hide radio buttons (fix interval and variable interval) in absence planner.
  public readonly popupContent = AbsencePopupComponent;
  public readonly faCircleInfo = faCircleInfo;
  public readonly TimeOfDayValues = TimeOfDayValues;
  public readonly IntervalTypes = IntervalTypes;
  public readonly timeDialogFormControls = timeDialogFormControls;
  public readonly FixInterval = FixInterval;

  private readonly subs = new SubSink();

  // // DI

  constructor(public readonly vcRef: ViewContainerRef) {}

  ngOnInit(): void {
    const isIntervalCtrl = this.form().controls[timeDialogFormControls.Interval];
    if (typeof isIntervalCtrl !== 'undefined') {
      this.intervalSelectable.set(true);
      this.subs.sink = this.form().controls[timeDialogFormControls.Interval].valueChanges.subscribe(
        (value) => {
          this.fixIntervalDropdownVisible.set(value === IntervalTypes.FixInterval);
        },
      );
    }
  }

  ngAfterViewInit(): void {
    const dateToControl = this.form().controls[timeDialogFormControls.DateTo];
    const timeToControl = this.form().controls[timeDialogFormControls.TimeTo];

    // Hide date to control and time to control for active time blocks.
    if (this.timeBlock().timeBlockModel.isActive) {
      dateToControl.disable();
      timeToControl.disable();
      return;
    }

    const isFixIntervalTimeBlock = this.timeBlock().timeBlockModel.fixInterval !== null;

    if (isFixIntervalTimeBlock) {
      const workTimeStart = this.workTimeStart();
      const workTimeEnd = this.workTimeEnd();
      const timeFromControl = this.form().controls[timeDialogFormControls.TimeFrom];
      timeFromControl.patchValue(workTimeStart);
      timeToControl.patchValue(workTimeEnd);
      return;
    }
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
